import React, { useContext, useState } from 'react'

const MenuContext = React.createContext()

export const MenuProvider = ({ children }) => {
  const [menu, setMenu] = useState({ products: [], combos: [] });
  return (
    <MenuContext.Provider value={{ menu, setMenu }}>
      {children}
    </MenuContext.Provider>
  )
}

export const useMenu = () => {
  const { menu, setMenu } = useContext(MenuContext)
  return { menu, setMenu }
}

